import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import EmailPreferences from "./email-preferences";
import { LOAD_SYNCED_EMAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { LOAD_EMAIL_SIGNATURE, UPDATE_EMAIL_SIGNATURE } from "@Broker/@Modules/main/store/account/account-actions";
import EmailPreferencesLoader from "./email-preferences-loader";
import { showToast } from "@Shared/utils/constants";
import Err from "../../../../routes/error";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailPreferencesContainer",
  components: {
    EmailPreferences,
    EmailPreferencesLoader
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    },
    nylasAccount: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      email: "",
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["accountPreferences"])), mapState("SettingsStore", ["syncedEmails"])),
  watch: {
    saving(value) {
      if (!value) return;
      this.$refs.emailPreferences.handleSubmit();
    }
  },
  async mounted() {
    this.loading = true;
    await _Promise.all([this.LOAD_EMAIL_SIGNATURE(), this.LOAD_SYNCED_EMAILS()]);
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [LOAD_EMAIL_SIGNATURE, UPDATE_EMAIL_SIGNATURE])), mapActions("SettingsStore", [LOAD_SYNCED_EMAILS])), {}, {
    async handleSubmit(emailSignature) {
      this.loading = true;
      try {
        await this.UPDATE_EMAIL_SIGNATURE(emailSignature);
        showToast("success", "emailPreferencesUpdated");
        this.$emit("finish-saving", true);
      } catch (e) {
        this.$emit("finish-saving", false);
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    }
  })
});